
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/interest",
      function () {
        return require("private-next-pages/interest.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/interest"])
      });
    }
  